// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import App from './App'
import router from './router'
import VueTranslate from 'vue-translate-plugin'
import Meta from 'vue-meta'

import VueResource from 'vue-resource'

import 'lodash'
import 'pixi.js'
import 'gsap/TweenMax'

Vue.use(VueResource)
Vue.use(VueTranslate)
Vue.use(Meta)

Vue.config.productionTip = false

/* analytics */
Vue.use(VueAnalytics, {
    id: 'UA-124285583-1',
    router
})

/* eslint-disable no-new */
new Vue({
  el: '#js-app',
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js